<template>
  <WsSlickSort
    :sortList="value"
    @sortList="$_updateList($event)"
  >
    <template v-slot="{sortItem, sortIndex}">
      <WsSortItem
        v-if="!sortItem[`${textKey}`]"
        :error="true"
      >
        <v-icon
          size="20"
          class="mr-2"
        >mdi-information</v-icon>
        <span>{{errorMessages[0]}}</span>
      </WsSortItem>
      <WsSortItem v-else>
        {{sortItem[`${textKey}`]}}
      </WsSortItem>
      <WsSortList
        v-if="sortItem.layers"
        :value="sortItem.layers"
        :errorMessages="errorMessages"
        class="ml-10"
        @sortList="$_updateSubList($event, sortIndex)"
      />
    </template>
  </WsSlickSort>
</template>

<script>
export default {
  props: {
    value:{},
    textKey: {
      type: String,
      default: 'name',
    },
    errorMessages: {
      type: Array,
      default(){
        return ['尚未有資料']
      }
    }
  },
  methods: {
    $_updateList($event){
      this.$emit('sortList', $event)
    },
    $_updateSubList($event, sortIndex) {
      const _value = [...this.value]
      _value[sortIndex].layers = $event
      this.$emit('sortList', _value)
    }
  }
}
</script>